import type { IBreadcrumb } from '@/components/ui/Breadcrumbs/Breadcrumb/interfaces'
import { agroservicesBreadcrumb, homeBreadcrumb } from '@/components/ui/Breadcrumbs/constants'

export const breadcrumbs: IBreadcrumb[] = [homeBreadcrumb, agroservicesBreadcrumb, { captionId: 'breadcrumbs.agroservices.faq' }]
